"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _MenuButton = _interopRequireDefault(require("../MenuButton"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Tag = _interopRequireDefault(require("../Tag"));

var _TruncateWithShow = _interopRequireDefault(require("../TruncateWithShow"));

var _MediaMosaic = _interopRequireDefault(require("../MediaMosaic"));

var _MessageSince = _interopRequireDefault(require("../MessageSince"));

var _MessageMediaAttachment = _interopRequireDefault(require("../MessageMediaAttachment"));

var _styled = require("./styled");

var MessageItem = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(MessageItem, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(MessageItem);

  function MessageItem() {
    (0, _classCallCheck2["default"])(this, MessageItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MessageItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          author = _this$props.author,
          avatar = _this$props.avatar,
          createdAt = _this$props.createdAt,
          isCoach = _this$props.isCoach,
          coachString = _this$props.coachString,
          body = _this$props.body,
          messageStatusLikes = _this$props.messageStatusLikes,
          messageStatusComments = _this$props.messageStatusComments,
          messageActionLike = _this$props.messageActionLike,
          messageActionComment = _this$props.messageActionComment,
          menuActions = _this$props.menuActions,
          comments = _this$props.comments,
          messageEditor = _this$props.messageEditor,
          onLoadMoreComments = _this$props.onLoadMoreComments,
          numberOfShownComments = _this$props.numberOfShownComments,
          seeMoreCommentsText = _this$props.seeMoreCommentsText,
          showMoreString = _this$props.showMoreString,
          imagesAndVideos = _this$props.imagesAndVideos,
          links = _this$props.links,
          pdfs = _this$props.pdfs;
      return /*#__PURE__*/_react["default"].createElement(_styled.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_styled.AvatarWrapper, null, avatar), /*#__PURE__*/_react["default"].createElement(_styled.Card, {
        elevation: 0
      }, /*#__PURE__*/_react["default"].createElement(_styled.CardHeader, {
        disableTypography: true,
        title: /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          container: true,
          alignItems: "center",
          spacing: 2
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "subtitle1"
        }, author)), isCoach && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true
        }, /*#__PURE__*/_react["default"].createElement(_Tag["default"], {
          ghost: true,
          color: _colors["default"].liva[400]
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          color: "inherit",
          variant: "caption"
        }, coachString)))),
        subheader: /*#__PURE__*/_react["default"].createElement(_MessageSince["default"], {
          timeStamp: createdAt
        }),
        action: menuActions && menuActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_MenuButton["default"], {
          id: "post-".concat(id, "-action-button")
        }, menuActions)
      }), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, /*#__PURE__*/_react["default"].createElement(_TruncateWithShow["default"], {
        showMoreString: showMoreString
      }, body)), /*#__PURE__*/_react["default"].createElement(_styled.MessageMediaWrapper, null, /*#__PURE__*/_react["default"].createElement(_MediaMosaic["default"], {
        id: "".concat(id, "-media-mosaic"),
        media: imagesAndVideos
      }), links.map(function (document) {
        return /*#__PURE__*/_react["default"].createElement(_MessageMediaAttachment["default"], {
          id: "post-".concat(id, "-document-").concat(document.uuid),
          key: document.uuid,
          type: document.type,
          name: /*#__PURE__*/_react["default"].createElement("a", {
            href: document.metadata.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, document.metadata.title)
        });
      }), pdfs.map(function (document) {
        return /*#__PURE__*/_react["default"].createElement(_MessageMediaAttachment["default"], {
          id: "post-".concat(id, "-document-").concat(document.uuid),
          key: document.uuid,
          type: document.type,
          name: /*#__PURE__*/_react["default"].createElement("a", {
            href: document.src,
            target: "_blank",
            rel: "noopener noreferrer"
          }, document.metadata.title)
        });
      }))), (messageStatusLikes || messageStatusComments) && /*#__PURE__*/_react["default"].createElement(_styled.CardActions, {
        disableActionSpacing: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        justify: "space-between"
      }, messageStatusLikes && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, messageStatusLikes), messageStatusComments && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, messageStatusComments))), (messageActionLike || messageActionComment) && /*#__PURE__*/_react["default"].createElement(_styled.CardActionsFullWidth, {
        disableActionSpacing: true
      }, /*#__PURE__*/_react["default"].createElement(_styled.GridBordered, {
        container: true,
        justify: "center"
      }, messageActionLike && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6
      }, messageActionLike), messageActionComment && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6
      }, messageActionComment))), comments && comments.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, numberOfShownComments < comments.length && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        justify: "center"
      }, /*#__PURE__*/_react["default"].createElement(_styled.SeeMoreCommentsButton, {
        id: "post-".concat(id, "-see-more-comments-button"),
        flat: true,
        info: true,
        onClick: onLoadMoreComments
      }, seeMoreCommentsText)), /*#__PURE__*/_react["default"].createElement(_styled.CommentsWrapper, null, comments.slice(-numberOfShownComments, comments.length))), messageEditor));
    }
  }]);
  return MessageItem;
}(_react["default"].PureComponent);

MessageItem.defaultProps = {
  isCoach: false,
  coachString: null,
  comments: null,
  menuActions: null,
  messageStatusLikes: null,
  messageStatusComments: null,
  messageActionLike: null,
  messageActionComment: null,
  messageEditor: null,
  seeMoreCommentsText: null,
  showMoreString: ''
};
var _default = MessageItem;
exports["default"] = _default;